exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "section[data-v-6e7fed5e]{position:relative;height:120px}main[data-v-6e7fed5e]{position:absolute;width:100%}.boxUp[data-v-6e7fed5e],main[data-v-6e7fed5e]{text-align:center}.boxUp[data-v-6e7fed5e]{font-size:2em;color:#fff;margin-top:-10px}.version[data-v-6e7fed5e]{left:10px}.powered[data-v-6e7fed5e],.version[data-v-6e7fed5e]{position:absolute;bottom:10px}.powered[data-v-6e7fed5e]{right:10px}.leftUpcorner[data-v-6e7fed5e]{border-radius:0 5px 5px 5px;background-color:#0078b6}", ""]);

// exports
